import type { RuleHandler } from "../types";

const checkMaximumOutcomes: RuleHandler = (context, requirement) => {
  const maxOutcomes = requirement.userDrivenAttributes?.maximumOutcomes ?? 0;

  return maxOutcomes >= context.selection.subOutcomesCount;
};

export { checkMaximumOutcomes };
